import { render, staticRenderFns } from "./interest_indicator.vue?vue&type=template&id=0348ae36&"
import script from "./interest_indicator.vue?vue&type=script&lang=js&"
export * from "./interest_indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0348ae36')) {
      api.createRecord('0348ae36', component.options)
    } else {
      api.reload('0348ae36', component.options)
    }
    module.hot.accept("./interest_indicator.vue?vue&type=template&id=0348ae36&", function () {
      api.rerender('0348ae36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/interest_indicator.vue"
export default component.exports